import React from 'react'
import PropTypes from 'prop-types'
import AdminHSSetup from 'components/AdminHSSetup'
import HighSchoolLaunchSnapshot from 'components/admin/LaunchSnapshot/HighSchool'
import { TOOLTIP_LOCATIONS, TOOLTIP_PROGRAMS } from 'utils/tooltipHelpers'
import { HEADER_TEXT } from './constants'
import {
  HeaderContainer,
  StyledBaseContainer,
  StyledAdminExportDownloadButton,
  StyledHeaderTwo,
} from './component.styles'

const AdminHSSingleSiteView = ({ programKey, site }) => {
  if (!site || Object.keys(site).length === 0) {
    return null
  }
  const { preferences, siteId, siteName } = site || {}
  const { isLaunched, isSetup } = preferences || {}
  return (
    <>
      {isLaunched && isSetup ? (
        <StyledBaseContainer>
          <HeaderContainer>
            <StyledHeaderTwo>{HEADER_TEXT}</StyledHeaderTwo>
            <StyledAdminExportDownloadButton
              programKey={TOOLTIP_PROGRAMS.HS}
              tooltipLocation={TOOLTIP_LOCATIONS.EXPORT_BUTTON}
            />
          </HeaderContainer>
          <HighSchoolLaunchSnapshot programKey={programKey} site={site} />
        </StyledBaseContainer>
      ) : (
        <AdminHSSetup
          preferences={preferences}
          programKey={programKey}
          showHairline={true}
          siteId={siteId}
          siteName={siteName}
        />
      )}
    </>
  )
}

AdminHSSingleSiteView.propTypes = {
  programKey: PropTypes.string,
  site: PropTypes.object,
}

export default AdminHSSingleSiteView
